<template>
    <RentalsListingsShell>

        <CardShell>

            <!-- heading -->
            <BackLinkHeading text="Invoices" route="/rentals-listings-mobile" linkText="My Rentals & Listings"/>

            <!-- invoice list -->
            <HugeSpinner v-if="loadingInvoices"/>
            <div v-else v-for="(invoice, index) in invoices" :key="index">
                <InvoiceListItem  :invoiceId="invoice.id" :rentalDate="invoice.paymentDate"/>
            </div>
        </CardShell>

    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import InvoiceListItem from '@/components/rentalsListings/invoices/InvoiceListItem.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        RentalsListingsShell,
        CardShell,
        BackLinkHeading,
        InvoiceListItem,
        HugeSpinner
    },
    computed: {
        ...mapState('invoices', ['invoices', 'loadingInvoices'])
    },
    methods: {
        ...mapActions('invoices', ['getInvoices'])
    },
    created: function() {
        this.getInvoices();
    }
};
</script>
